import { useMemo } from "react"

import { useTransportQuery } from "@/transport"

import { useDebounce } from "@/hooks/useDebounce"

const SEARCH_DEBOUNCE_MS = 500

export function useMetadataSuggestionsTransport(
  key: string,
  search: string,
  enabled: boolean,
) {
  const lookup = useMemo(() => ({ key, search }), [key, search])
  const debouncedLookup = useDebounce(lookup, SEARCH_DEBOUNCE_MS)
  const isLookupSettled =
    key === debouncedLookup.key && search === debouncedLookup.search
  const keys = useTransportQuery({
    operation: "getMetricMetadataKeys",
    request: { is_monitoring: true },
    options: {
      enabled,
      abortOnUnmount: true,
      retry: false,
      staleTime: 5 * 60 * 1000,
      select: (response) => response.keys ?? [],
    },
  })
  const values = useTransportQuery({
    operation: "getMetricMetadataValues",
    request: {
      is_monitoring: true,
      key: debouncedLookup.key,
      search: debouncedLookup.search || undefined,
    },
    options: {
      enabled: enabled && Boolean(key) && isLookupSettled,
      abortOnUnmount: true,
      retry: false,
      staleTime: 5 * 60 * 1000,
      select: (response) => response.values ?? [],
    },
  })

  return {
    keys: keys.data ?? [],
    values: key && isLookupSettled ? (values.data ?? []) : [],
    isLoading: keys.isFetching || values.isFetching,
    isError: keys.isError || values.isError,
    retry: () => {
      void keys.refetch()
      void values.refetch()
    },
  }
}
